export const formatDate = (isoDate: string): string => {
  const date = new Date(isoDate);
  return date.toLocaleDateString('ru-RU'); // выдаст формат типа 09.06.2025
};

// Получаем базовый URL API из переменных окружения
export const getApiBaseUrl = (): string => {
  return process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
};

// Получаем базовый URL для приложений (лендинг)
export const getApplyBaseUrl = (): string => {
  return process.env.REACT_APP_LANDING_URL || 'http://localhost:5173';
};

